module.exports = __webpack_public_path__ + "img/max-cloud-subtract.7742ace0.svg";